module.exports = new __parcel__URL__("shop_text.9dd37b9a.png").toString();